import styled from 'styled-components';
import { displayFlex } from '../../../styles/Mixins';
import { paragraphReg } from '../../../styles/Typography';
import colors from '../../../styles/Colors';
import ContextSnackbar from 'Components/Snackbar';
import { HeadingTwo } from 'Components/Headings';
import { MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { VENUES } from 'Queries/SuperAdmin';
import { EVENT_HISTORY_BY_EVENT_ID } from 'Queries/SuperAdmin/EventHistory';
import EventHistoryTable from 'Pages/SuperAdmin/EventHistory/EventHistoryTable';

const getOptions = data => {
  if (!data) return null;

  const options = data.map(data => (
    <MenuItem key={data.id} value={data.id}>
      ID: {data.id} {data.name}
    </MenuItem>
  ));

  return options;
};

function EventHistory(props) {
  const { className } = props;
  const [venues, setVenues] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState(null);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const { data: venuesData, loading: venuesLoading, error: venuesError } = useQuery(VENUES, {
    fetchPolicy: 'network-only'
  });

  const [getEventHistory, { data, loading: eventHistoryLoading, error: eventHistoryError }] = useLazyQuery(EVENT_HISTORY_BY_EVENT_ID, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (venuesData) {
      const sortedVenues = venuesData.venues.sort((a, b) => a.id - b.id);
      setVenues(sortedVenues);
    }
  }, [venuesData]);

  useEffect(() => {
    if (selectedVenue && selectedVenue.events) {
      // Sort events by ID or any other criteria you prefer
      const sortedEvents = selectedVenue.events.sort((a, b) => b.id - a.id);
      setEvents(sortedEvents);
      // Reset selected event when venue changes
      setSelectedEvent(null);
    } else {
      setEvents([]);
      setSelectedEvent(null);
    }
  }, [selectedVenue]);

  useEffect(() => {
    if (selectedEvent) {
      getEventHistory({
        variables: {
          input: {
            eventId: +selectedEvent.id
          }
        }
      });
    }
  }, [selectedEvent]);

  const handleVenueChange = e => {
    const venue = venues.filter(venue => venue.id === e.target.value)[0];
    setSelectedVenue(venue);
  };

  const handleEventChange = e => {
    const event = events.filter(event => event.id === e.target.value)[0];
    setSelectedEvent(event);
  };

  return (
    <>
      <div className={className}>
        <ContextSnackbar />
        <div className={`${className}__page-header`}>
          <div className={`${className}__header-wrapper`}>
            <HeadingTwo label="EVENT HISTORY" />
          </div>
        </div>
      </div>
      <div className={className}>
        <div className={`${className}__page-body`}>
          <div className={`${className}__selector-container`}>
            <div className={`${className}__selector-item`}>
              <h3>Choose a venue</h3>
              {venues && !venuesLoading && !venuesError && (
                <Select data-testid="map-select-venue" onChange={handleVenueChange} value={selectedVenue?.id || ''} disableUnderline>
                  {getOptions(venues)}
                </Select>
              )}
            </div>

            <div className={`${className}__selector-item`}>
              <h3>Choose an event</h3>
              <Select
                data-testid="map-select-event"
                onChange={handleEventChange}
                value={selectedEvent?.id || ''}
                disableUnderline
                disabled={!selectedVenue || events.length === 0}>
                {getOptions(events)}
              </Select>
            </div>
            <div>
              <h3>Event History</h3>
              <EventHistoryTable
                eventHistory={data?.eventHistory ? [...data.eventHistory].sort((a, b) => +a.id - +b.id) : []}
                loading={eventHistoryLoading}
                error={eventHistoryError}
                venueTimeZone={selectedVenue?.timeZone}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SuperAdminEventHistory = styled(EventHistory)`
  &&& {
    ${displayFlex}
    align-items: center;
    width: 100%;
    height: auto;
    padding: 12px 0 11px 20px;
    ${paragraphReg}
    font-size: 14px;
    text-align: left;
    background-color: ${colors.background.primary};
    color: ${colors.text};
    border-radius: 3px;
  }

  &__page-header {
    text-align: left;
    width: 100%;
    border-bottom: 1px solid rgb(200, 214, 229);
    &&& {
      margin: 65px 0 25px;
    }
  }

  &__page-body {
    text-align: left;
    width: 100%;
    &&& {
      margin: 0;
      padding: 10px;
    }

    h3 {
      text-transform: uppercase;
      font-family: IBMPlexSans-Bold;
      font-size: 12px;
      font-weight: 400;
      color: rgb(79, 93, 109);
      margin-top: 0px;
      margin-bottom: 3px;
    }
  }

  &__selector-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__selector-item {
    margin-bottom: 10px;
  }

  &__page-body-child {
    margin-top: 20px;
  }

  &__header-wrapper {
    margin: 20px 0px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .MuiInputBase-root {
    border: ${colors.text.lightGray2} 1px solid;
    border-radius: 3px;
    padding: 0 10px;
    min-width: 300px;
  }

  .MuiSvgIcon-root {
    width: 0.8em;
    height: 0.8em;
  }

  .MuiIconButton-root {
    padding-top: 6px;
  }

  .line {
    background: ${colors.border.primary};
    height: 1px;
    flex: 1;
    position: relative;
    top: 11px;
  }
`;

export default SuperAdminEventHistory;
